module.exports = __webpack_public_path__ + "static/media/whylabel.79c484d6.png";